import authApi from "@/api/auth.api";
import store from "../store/store";

export const authService = (function() {
  "use strict";

  async function login(authDto) {
    try {
      let result = await authApi.validateUser(authDto);
      return result.data;
    } catch (exception) {
      console.log(exception);
      return null;
    }
  }

  /**
   * Obtiene el token para la recuperación de contraseña
   * @param {*} authDto
   */
  async function getResetPasswordToken(authDto) {
    try {
      let result = await authApi.getResetPasswordToken(authDto);
      return result.data;
    } catch (exception) {
      console.log(exception);
      return { token: "" };
    }
  }

  /**
   * Obtener un nuevo token con el payload actualizado, pero el mismo vencimiento que el token anterior
   */
  async function refreshTokenPayload() {
    try {
      let response = await authApi.refreshTokenPayload();
      store.dispatch("user/setToken", response.data);
    } catch (exception) {
      store.dispatch("user/setToken", null);
    }
  }

  async function refreshSessionData() {
    try {
      let sessionData = await authApi.refreshToken();
      store.dispatch("user/setToken", sessionData.sessionToken);
      await this.updateSessionData(sessionData);
    } catch (exception) {
      store.dispatch("user/setToken", null);
    }
  }

  async function updateSessionData(sessionData) {
    store.dispatch("user/setPrivileges", sessionData.user.privileges);
    store.dispatch("user/setAdmin", sessionData.user.superAdmin || false);
  }


  async function refreshTokenSecondFactor (enterprise, secondFactorToken) {
    const result = await authApi.refreshTokenSecondFactor({ enterprise, secondFactorToken })
    return result.data
  }

  return {
    login,
    getResetPasswordToken,
    refreshTokenPayload,
    updateSessionData,
    refreshSessionData,
    refreshTokenSecondFactor
  };
})();
